
<template>
  <div class="container text-center mt-3">
    <section class="card-selection-wrapper">
      <div class="card-content">
        <div
          class="row mt-2 no-gutters align-item-center justify-content-center"
        >
          <div class="col-md-4">
            <div class="card">
              <div class="card-body mb-0 pb-0" v-if="!selectedCaptain">
                <a href="JavaScript:void(0)" @click="showSelection('captain')">
                  <i class="fal fa-plus"></i>
                </a>
                <h1 class="card-text mb-0">Choose</h1>
                <h4 class="text-uppercase">your captain</h4>
              </div>
              <div class="card-body" v-if="selectedCaptain">
                <img
                  class="card-img-top"
                  :src="getImgUrl(selectedCaptain.img)"
                  alt=""
                  @click.prevent="showSelection('captain')"
                />
              </div>
            </div>
          </div>
          <div
            class="
              col-md-4
              d-flex
              justify-content-center
              align-items-center
              flex-column
            "
          >
            <div class="card-1">
              <div
                class="card-body h-100 justify-content-between"
                v-if="!selectedPet"
              >
                <a href="JavaScript:void(0)" @click="showSelection('pet')">
                  <i class="fal fa-plus mt-3"></i>
                </a>
                <h4 class="card-text mb-0">Pet</h4>
                <p class="req-food">Optional</p>
              </div>
              <div class="card-body" v-if="selectedPet">
                <img
                  class="card-img-top"
                  :src="getImgUrl(selectedPet.img)"
                  alt=""
                  @click.prevent="showSelection('pet')"
                />
              </div>
            </div>
          </div>
          <div class="col-md-4">
            <div class="card">
              <div class="card-body" v-if="selectedShip">
                <img
                  class="card-img-top"
                  :src="getImgUrl(selectedShip.img)"
                  alt=""
                  @click.prevent="showSelection('ship')"
                />
              </div>
              <div class="card-body pb-0" v-if="!selectedShip">
                <a href="JavaScript:void(0)" @click="showSelection('ship')">
                  <i class="fal fa-plus"></i>
                </a>
                <h1 class="card-text mb-0">Choose</h1>
                <h4 class="text-uppercase font-weight-bold">your ship</h4>
              </div>
            </div>
          </div>
        </div>
      </div>

      <CardSelectModal
        :error="error"
        v-if="showModal"
        :cards="info"
        :cardName="card"
        :selectedLocation="selectedLocation"
        v-on:w-modal-hide-click="showModal = false"
      />
    </section>
    <footer class="d-flex justify-content-between align-items-center container">
      <div class="back-btn">
        <router-link to="/dashboard">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            class="h-6 w-6"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M15 19l-7-7 7-7"
            />
          </svg>
        </router-link>
      </div>
      <div class="select-btn">
        <a href="JavaScript:void(0)" class="btn" @click.prevent="attack()">
          <span class="d-block text-black p-0 m-0"></span>
          Join Battle
        </a>
      </div>
    </footer>
  </div>
</template>

<script>
import CardSelectModal from "../components/CardSelectModal.vue";
import ApiService from "../services";
import { mapGetters } from "vuex";
import "vue-loading-overlay/dist/vue-loading.css";
import { useToast } from "vue-toastification";
const toast = useToast();
export default {
  name: "Discover",
  computed: {
    ...mapGetters([
      "selectedCaptain",
      "selectedShip",
      "selectedPet",
      "attackData",
    ]),
  },
  data() {
    return {
      showModal: false,
      card: null,
      foodRequired: 1,
      Loading: true,
      location: "Europe",
    };
  },
  components: {
    CardSelectModal,
  },
  mounted() {
    this.checkAttack();
    this.Loading = true;
    ApiService.getTable(
      "divisions",
      null,
      async (result) => {
        if (result.rows.length > 0) {
          this.info = result.rows;
          this.selectedLocation = this.info.filter(
            (el) => el.location == this.location
          )[0];
          this.Loading = false;
        }
      },
      (error) => {
        this.Loading = false;
        toast.error(error);
      }
    );
  },
  methods: {
    showSelection(option) {
      this.card = option;
      this.showModal = true;
    },
    getImgUrl(hash) {
      let url = "http://ipfs.io/ipfs/" + hash;
      return "//lostsailor/images.weserv.nl/?url=" + url + "&w=500";
    },
    async checkAttack() {
      await ApiService.getTableAll(
        "battle.users",
        async (result) => {
          if (result.rows.length > 0) {
            this.myRec = result.rows.filter(
              (i) => i.account == localStorage.getItem("wax_user")
            );
            if (this.myRec.length > 0) {
              this.$router.push("/attack");
            }
          }
        },
        (error) => {
          this.isLoading = false;
          toast.error(error);
        }
      );
    },
    async attack() {
      if (this.attackData.length < 2) {
        toast.error(
          "Missing cards, you need foods,supply,captain and a ship to attack."
        );
        return;
      }
      const data = {
        from: localStorage.getItem("wax_user"),
        to: process.env.VUE_APP_CONTRACT,
        asset_ids: this.attackData,
        memo: `joinbattle:0`,
      };
      await ApiService.attack(
        data,
        (res) => {
          if (res.processed) {
            toast.success("Battle has been Joined, redirecting...");
            setTimeout(() => {
              this.$router.push("attack");
            }, 2000);
          }
        },
        (error) => {
          this.error = ApiService.errorFormat(error);
          toast.error(this.error);
        }
      );
    },
  },
};
</script>

<style scoped>
.req-food {
  color: #990d2c;
  font-size: 10px;
  margin-bottom: 0;
  font-weight: 600;
}
.select-btn .btn {
  padding: 0 39px 8px !important;
  width: 100%;
  height: 56px;
}

.card-content {
  width: 60%;
  margin: auto;
}
.card-selection-wrapper {
  margin-top: 5%;
}
.card-selection-wrapper .btn {
  width: 100%;
}
footer {
  position: fixed;
  bottom: 40px;

  left: 0;
  right: 0;
}
</style>